import { convertBytesToMegabytes } from './utils';

const MIME_TYPES = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  svg: 'image/svg+xml',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  webm: 'video/webm',
  mkv: 'video/x-matroska',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const getFileNameFromUrl = url => {
  try {
    return decodeURIComponent(url.split('/').pop().split('?')[0]);
  } catch {
    return 'file';
  }
};

export const getMimeTypeFromUrl = url => {
  const ext = url.split(/[?#]/)[0].split('.').pop().toLowerCase();
  return MIME_TYPES[ext] || null;
};

export const isImageUrl = url =>
  /\.(jpe?g|png|gif|webp|bmp|svg)(\?|$)/i.test(url);

export const isVideoUrl = url => /\.(mp4|mov|avi|webm|mkv)(\?|$)/i.test(url);

export const downloadUrlToFile = async url => {
  const response = await fetch(url);
  const blob = await response.blob();
  const filename = getFileNameFromUrl(url);
  const type =
    blob.type && blob.type !== 'application/octet-stream'
      ? blob.type
      : getMimeTypeFromUrl(url) || blob.type;
  return new File([blob], filename, { type });
};

export const downloadUrlsToUploadFiles = async urls => {
  const files = [];
  for (const url of urls) {
    try {
      const file = await downloadUrlToFile(url);
      const isImg = file.type.indexOf('image') === 0;
      const thumbnail = isImg ? URL.createObjectURL(file) : null;
      files.push({
        status: '',
        file,
        ...(thumbnail ? { thumbnail } : {}),
        size: convertBytesToMegabytes(file.size),
      });
    } catch (e) {
      console.error('Failed to download file:', url, e);
    }
  }
  return files;
};
